import './globals';
import {Tooltip} from "bootstrap";

((PageLoadedQueue) => {
    PageLoadedQueue.addFunction(() => {
        document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));
    });
})(window.PageLoadedQueue);
